<script>
    import {onDestroy, onMount} from 'svelte';
	import { FormIcon, FormIconS, LinkIcon, LinkIconS, NewScenarioIcon, NewScenarioIconS, ScenarioConnectIcon, ScenarioConnectIconS, TextIcon, TextIconS, YoutubeIcon, YoutubeIconS } from '../views/svg'
    export let button;
    export let bot;
    export let index;
    export let blockDesign;

    let navFlag = false;

    const clickScenarioConnect = () => {
        
    }

    const changeTargetType = (e) => {
        const targetType = e.target.closest(".scenario-con").dataset.type;
        navFlag = false;
        switch(targetType) {
            case "NEW":
				if (!bot.isAuthority("storyCnt", bot.getScenarioListSize() + 1)) {
					return false;
				}
                bot.defaultChar.addScenario(button);
                break;
            case "PRIVACY":
				if (!bot.isAuthority("buttonType", "PRIVACY")) {
					return false;
				}
                button.changeTargetTypeForPrivacy();
                break;
			case "INPUT":
				if (!bot.isAuthority("buttonType", "INPUT")) {
					return false;
				}
				button.changeTargetType(targetType);
				break;
            case "SCENARIO":
                navFlag = true;
            default:
                button.changeTargetType(targetType);
                break;
        }
    }

    const changeTargetTypeForDelete = () => {
        button.deleteTargetType();
        navFlag = false;
    }

    const deleteTargetLink = () => {
        button.deleteTargetLink();
    }

    const changeTargetScenario = (scenarioId, targetType) => {
        button.changeTargetScenario(scenarioId, targetType);
        navFlag = false;
    }

    const changeButtonTargetLink = (e) => {
        const targetType = e.target.dataset.type;
        let targetLink = e.target.value;
        if (targetLink.includes("watch") && targetType ==="IFRAME") {
            const urlObject = new URL(targetLink);
            targetLink = `${urlObject.origin}/embed/${urlObject.searchParams.get("v")}`;
        } else if (targetLink.includes("youtu.be") && targetType ==="IFRAME") {
            const urlObject = new URL(targetLink);
            targetLink = `https://www.youtube.com/embed${urlObject.pathname}`;
        } else if (targetLink.includes("shorts") && targetType === "IFRAME") {
            targetLink = targetLink.replace("shorts", "embed");
        }
        button.changeTargetLink(targetLink, targetType);
    }
    
    const clickNavbar = () => {
        navFlag = !navFlag;
    }

</script>
<div data-delay="0" data-hover="true" class="dropdown-2 scenario w-dropdown" class:block-design={blockDesign}>
    <div class="select-wrapper">
        <div class="dropdown-toggle-scenario w-dropdown-toggle" id="w-dropdown-toggle-2"
            aria-controls="w-dropdown-list-2" aria-haspopup="menu" aria-expanded="false" role="button" tabindex="0" class:block-design={blockDesign} class:margin-bottom-4={button.isTargetTypeInput()} on:click={clickNavbar}>
            {#if button.isTargetTypeIframe()}
            <img class="selected-image" class:block-design={blockDesign} src="/static/images/youtube-icon-s.svg" loading="lazy" alt="">
            <input class="name-text-form story w-input" data-type="IFRAME" value={button.targetLink || ""} placeholder={"원하시는 링크 주소를 입력하세요."} on:change={(e) => changeButtonTargetLink(e)}>
            <div class="delete-button pointer" on:click|stopPropagation={deleteTargetLink}></div>
            {:else if button.isTargetTypeLink()}
            <img class="selected-image" class:block-design={blockDesign} src="/static/images/link-icon-s.svg" loading="lazy" alt="">
            <input class="name-text-form story w-input" data-type="LINK" value={button.targetLink || ""} placeholder={"원하시는 링크 주소를 입력하세요."} on:change={(e) => changeButtonTargetLink(e)}>
            <div class="delete-button pointer" on:click|stopPropagation={deleteTargetLink}></div>
            {:else if button.isTargetTypeInput()}
            <div class="text-block-26">{"질의 응답폼 만들기"}</div>
            <div class="delete-button pointer" on:click|stopPropagation={changeTargetTypeForDelete}></div>
            {:else if button.isTargetTypePrivacy()}
            <div class="text-block-26">{"개인정보 입력폼 만들기"}</div>
            <div class="delete-button pointer" on:click|stopPropagation={changeTargetTypeForDelete}></div>
            {:else if button.isScenarioSelected()}
            <div class="selected-button-wrapper">
            <img class="selected-image" class:block-design={blockDesign} src="/static/images/scenario-connect-icon-s.svg" loading="lazy" alt="">
            <div class="icon-2 w-icon-dropdown-toggle" aria-hidden="true"></div>
            <div class="text-block-26">{button.getTargetScenarioTitle(button.targetScenarioId)}</div>
            </div>
            {:else if button.isScenarioSelectedExceptTarget()}
            <div class="selected-button-wrapper">
            <div class="icon-2 w-icon-dropdown-toggle" aria-hidden="true"></div>
            <div class="text-block-26">{"기존 섹션 연결하기"}</div>
            </div>
            {:else}
            <div class="selected-button-wrapper">
            <div class="icon-2 w-icon-dropdown-toggle" aria-hidden="true"></div>
            <div class="text-block-26">{"버튼에 해당하는 콘텐츠 선택"}</div>
            </div>
            {/if}
        </div>
        {#if button.isTargetTypeEmpty()}
        <nav class="dropdown-list-3 w-dropdown-list" class:w--open={navFlag} id="w-dropdown-list-2"
            aria-labelledby="w-dropdown-toggle-2" on:mouseleave={()=>navFlag = false}>
            <div class="dropdown-con-wrap">
                <div class="dropdown-title">
                    <div class="text-block-25">{"섹션 연결"}</div>
                </div>
                <div class="scenario-con" data-type="NEW" on:click={changeTargetType}>
					<NewScenarioIcon />
                    <!-- <img src="/static/images/new-scenario-icon.svg" loading="lazy" alt="" class="image-150"> -->
                    <div class="text-block-101">{"새로운 섹션 만들기"}</div>
                </div>
                <div class="scenario-con" data-type="SCENARIO" on:click={changeTargetType}>
					<ScenarioConnectIcon />
                    <!-- <img src="/static/images/scenario-connect-icon.svg" loading="lazy" alt="" class="image-150"> -->
                    <div class="text-block-101">{"기존 섹션 연결하기"}</div>
                </div>
            </div>
            <div class="dropdown-con-wrap">
                <div class="dropdown-title">
                    <div class="text-block-25">{"콘텐츠 연결"}</div>
                </div>
                <div class="scenario-con" data-type="LINK" on:click={changeTargetType}>
                    <LinkIcon />
                    <div class="text-block-101">{"링크 연결하기"}</div>
                </div>
                <div class="scenario-con" data-type="IFRAME" on:click={changeTargetType}>
                    <YoutubeIcon />
					<!-- <img src="/static/images/youtube-icon.svg" loading="lazy" alt="" class="image-150"> -->
                    <div class="text-block-101">{"유튜브 연결하기"}</div>
                </div>
            </div>
            <div class="dropdown-con-wrap">
                <div class="dropdown-title">
                    <div class="text-block-25">{"폼 연결"}</div>
					{#if !bot.isAvailableType("buttonType","INPUT")}
						<img class="contents-lock-image" src="/static/images/lock.svg" />
					{/if}
                </div>
                <div class="scenario-con" data-type="INPUT" on:click={changeTargetType}>
					<TextIcon />
                    <!-- <img src="/static/images/text-icon.svg" loading="lazy" alt="" class="image-150"> -->
                    <div class="text-block-101">{"질의응답폼 만들기"}</div>
                </div>
                <div class="scenario-con" data-type="PRIVACY" on:click={changeTargetType}>
                    <FormIcon />
					<!-- <img src="/static/images/form-icon.svg" loading="lazy" alt="" class="image-150"> -->
                    <div class="text-block-101">{"개인정보 입력폼 만들기"}</div>
                </div>
            </div>
        </nav>
        {:else if button.isTargetTypeScenario()}
        <nav class="dropdown-list-3 w-dropdown-list" class:w--open={navFlag} id="w-dropdown-list-2"
            aria-labelledby="w-dropdown-toggle-2" on:mouseleave={()=>navFlag = false}>
            <div class="dropdown-con-wrap">
                <div class="dropdown-title">
                    <div class="text-block-25">{"섹션 연결"}</div>
                </div>
                {#each button.getScenarioList() as scenario}
                <div class="scenario-con" on:click={()=>changeTargetScenario(scenario.id)}>
                    <ScenarioConnectIcon />
					<!-- <img src="/static/images/scenario-connect-icon.svg" loading="lazy" alt="" class="image-150"> -->
                    <div class="text-block-101">{scenario.title}</div>
                </div>
                {/each}
            </div>
        </nav>
        <div class="delete-button scenario-delete-button pointer" on:click={changeTargetTypeForDelete} class:block-design={blockDesign}></div>
        {:else if button.isTargetTypePrivacy()}
        <div class="form-button-check">
            <div class="text-block-102">{"받아 볼 고객정보"}</div>
            <div class="form-block-join w-form">
                <div id="email-form" name="email-form" data-name="Email Form" method="get">
                    <div class="form-wrap-inner center last">
                        <div class="checkbox-grid _3">
                            <!-- <label class="p-radio-btn">
                                <input type="checkbox" id="checkbox-7" name="checkbox-7" data-name="Checkbox 7" checked={button.isPrivacyContext("NAME")}>
                                <span class="checkbox-label-2 w-form-label" for="checkbox-7" on:click={button.changePrivacyContext("NAME")}>성함</span>
                            </label> -->
                            <label class="p-radio-btn" >
                                <!-- <div class="radio-btn" class:w--redirected-checked={button.isPrivacyContext("EMAIL")} on:click={button.changePrivacyContext("EMAIL")}></div> -->
                                <input type="checkbox" id="checkbox-7" name="checkbox-7" data-name="Checkbox 7" checked={button.isPrivacyContext("EMAIL")} on:click={button.changePrivacyContext("EMAIL")}>
                                <span class="checkbox-label-2 w-form-label" for="checkbox-7">{"이메일"}</span>
                            </label>
                            <label class="p-radio-btn">
                                <!-- <div class="radio-btn" class:w--redirected-checked={button.isPrivacyContext("PHONE")} on:click={button.changePrivacyContext("PHONE")}></div> -->
                                <input type="checkbox" id="checkbox-7" name="checkbox-7" data-name="Checkbox 7" checked={button.isPrivacyContext("PHONE")} on:click={button.changePrivacyContext("PHONE")}>
                                <span class="checkbox-label-2 w-form-label" for="checkbox-7">{"전화번호"}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="select-wrapper">
            <div class="dropdown-toggle-scenario w-dropdown-toggle" id="w-dropdown-toggle-2"
                aria-controls="w-dropdown-list-2" aria-haspopup="menu" aria-expanded="false" role="button" tabindex="0"
                on:click={()=>navFlag = !navFlag}>
                {#if button.isScenarioSelected()}
				<!-- <ScenarioConnectIconS /> -->
				<img class="selected-image" src="/static/images/scenario-connect-icon-s.svg" loading="lazy" alt="" />
                <div class="icon-2 w-icon-dropdown-toggle" aria-hidden="true"></div>
                <div class="text-block-26">{button.getTargetScenarioTitle(button.targetScenarioId)}</div>
                {:else}
                <div class="icon-2 w-icon-dropdown-toggle" aria-hidden="true"></div>
                <div class="text-block-26">{"입력 완료 시 다음으로 넘어갈 섹션을 선택해주세요!"}</div>
                {/if}
            </div>
            <nav class="dropdown-list-3 w-dropdown-list" class:w--open={navFlag} id="w-dropdown-list-2"
                aria-labelledby="w-dropdown-toggle-2" on:mouseleave={()=>navFlag = false}>
                <div class="dropdown-con-wrap">
                    <div class="dropdown-title">
                        <div class="text-block-25">{"섹션 연결"}</div>
                    </div>
                    {#each button.getScenarioList() as scenario}
                    <div class="scenario-con" on:click={()=>changeTargetScenario(scenario.id, "PRIVACY")}>
                        <ScenarioConnectIcon />
						<!-- <img src="/static/images/scenario-connect-icon.svg" loading="lazy" alt="" class="image-150"> -->
                        <div class="text-block-101">{scenario.title}</div>
                    </div>
                    {/each}
                </div>
            </nav>
        </div>
        {:else if button.isTargetTypeInput()}
        <div class="select-wrapper">
            <div class="dropdown-toggle-scenario w-dropdown-toggle" id="w-dropdown-toggle-2" aria-controls="w-dropdown-list-2"
                aria-haspopup="menu" aria-expanded="false" role="button" tabindex="0" on:click={()=>navFlag = !navFlag}>
                {#if button.isScenarioSelected()}
				<!-- <ScenarioConnectIconS /> -->
                <img class="selected-image" src="/static/images/scenario-connect-icon-s.svg" loading="lazy" alt="">
                <div class="icon-2 w-icon-dropdown-toggle" aria-hidden="true"></div>
                <div class="text-block-26">{button.getTargetScenarioTitle(button.targetScenarioId)}</div>
                {:else}
                <div class="icon-2 w-icon-dropdown-toggle" aria-hidden="true"></div>
                <div class="text-block-26">{"입력 완료 시 다음으로 넘어갈 섹션을 선택해주세요!"}</div>
                {/if}
            </div>
            <nav class="dropdown-list-3 w-dropdown-list" class:w--open={navFlag} id="w-dropdown-list-2"
                aria-labelledby="w-dropdown-toggle-2" on:mouseleave={()=>navFlag = false}>
                <div class="dropdown-con-wrap">
                    <div class="dropdown-title">
                        <div class="text-block-25">{"섹션 연결"}</div>
                    </div>
                    {#each button.getScenarioList() as scenario}
                    <div class="scenario-con" on:click={()=>changeTargetScenario(scenario.id, "INPUT")}>
                        <ScenarioConnectIcon />
						<!-- <img src="/static/images/scenario-connect-icon.svg" loading="lazy" alt="" class="image-150"> -->
                        <div class="text-block-101">{scenario.title}</div>
                    </div>
                    {/each}
                </div>
            </nav>
        </div>
        {/if}
    </div>
</div>
<style>

	.text-block-26 {
		overflow: hidden;
    	text-overflow: ellipsis;
	}

    .scenario-con {
        cursor: pointer;
		width: 315px;
		height: auto;
    	min-height: 50px;
    }

    .scenario-con:hover {
        border-radius: 5px;
        outline-color: rgb(29 26 199 / 66%);
        outline-offset: 0px;
        outline-style: solid;
        outline-width: 2px;
    }

    .select-wrapper {
        position: relative;
    }

    .delete-button {
        position: absolute;
        right: -21px;
        top: 7px;
    }

    .scenario-delete-button {
        top: 9px;
    }

    .dropdown-list-3 {
        position: relative;
    }

    .dropdown-list-3.w--open {
        margin-bottom: 0px;
    }

    .selected-image {
        position: absolute;
        left: -21px;
        top: 10px;
    }

    .dropdown-toggle-scenario {
        align-items: center;
        display: flex;
        height: 38px;
    }
    .dropdown-toggle-scenario.block-design {
        width: 100%;
    }

    .dropdown-toggle-scenario input {
        font-family: 'Noto sans kr 500', sans-serif;
        font-size: 12px;
        font-weight: 500;
        text-align: left;
    }

    .radio-btn {
        cursor: pointer;
    }

    .form-button-check {
        margin-bottom: 4px;
        margin-top: 4px;
    }

    .scenario-delete-button.block-design {
        display: none;
    }
    
    .selected-image.block-design {
        display: none;
    }

    .dropdown-2.block-design {
        width: 100%;
    }
    .dropdown-2.scenario {
        margin-bottom: 4px;
    }
    .margin-bottom-4 {
        margin-bottom: 4px;
    }
    .checkbox-label-2 {
        margin-left: 10px;
    }
    .p-radio-btn {
        margin-right: 34px;
    }
    .selected-button-wrapper {
        width: 100%;
    }
	.dropdown-title {
		position: relative;
	}
	.contents-lock-image {
		display: inline-block;
		width: 20px;
	}
	.text-block-25 {
		margin-right: 5px;
	}

	/* ── shadcn 토큰 리스킨: 트리거=셀렉트박스, 리스트=팝오버 (뒤 규칙이 이김) ── */
	.dropdown-toggle-scenario {
		border: 1px solid hsl(var(--sb-input));
		border-radius: 6px;
		background: hsl(var(--sb-background));
		height: 40px;
		padding: 0 10px;
	}
	.dropdown-toggle-scenario input,
	.name-text-form.story {
		background: transparent;
		color: hsl(var(--sb-foreground));
		border: none;
	}
	.text-block-26 {
		color: hsl(var(--sb-foreground));
	}
	.dropdown-list-3.w-dropdown-list {
		background: hsl(var(--sb-card));
		border: 1px solid hsl(var(--sb-border));
		border-radius: 10px;
		box-shadow: 0 8px 24px rgb(0 0 0 / 0.12);
		padding: 6px;
		margin-top: 4px;
	}
	.scenario-con:hover {
		outline: none;
		background: hsl(var(--sb-muted));
		border-radius: 6px;
	}
	.text-block-25 {
		color: hsl(var(--sb-muted-foreground));
	}
	.text-block-101 {
		color: hsl(var(--sb-foreground));
	}
	.checkbox-label-2 {
		color: hsl(var(--sb-foreground));
	}
</style>